module.exports = __webpack_public_path__ + "img/mlh_honor_5.2b3e420d.png";